<div *ngIf="message" role="alert" class="m-6">
  <div class="flex items-start gap-3 rounded-lg border border-red-200 bg-red-50 px-4 py-3">
    <svg class="h-5 w-5 flex-shrink-0 text-red-600 mt-0.5" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"
      fill="currentColor" aria-hidden="true">
      <path fill-rule="evenodd"
        d="M18 10A8 8 0 11 2 10a8 8 0 0116 0zm-8-4a1 1 0 00-1 1v3a1 1 0 002 0V7a1 1 0 00-1-1zm0 8a1 1 0 100-2 1 1 0 000 2z"
        clip-rule="evenodd" />
    </svg>
    <div>
      <p class="text-sm font-semibold text-red-800">Error</p>
      <p class="text-sm text-red-700">{{message}}</p>
    </div>
  </div>
</div>
